/*** IMPORTS FROM imports-loader ***/
var define = false;

import { showElement, hideElement } from '../util/showHideElements';
import { addFilterClass, removeFilterClass } from '../util/profileCardFilters';
import profileCardMasonry from '../util/profileCardMasonry';

const hiddenClassName = 'hidden-by-studentname';
const filteredClassName = 'filtered-by-studentname';

// Check whether any words in a query are found in any words of a term.
function matchWords(a, b) {
  // Use 'some' to short-circuit once a match is found.
  if (typeof a === 'string' && typeof b === 'string') {
    return a.split(/[\s,-]+/).some((aWord) => {
      return b.split(/[\s,-]+/).some((bWord) => {
        // If match found, this will short-circuit up the chain.
        return RegExp(bWord, 'i').test(aWord);
      });
    });
  }
}

export default function () {
  const profileCardsLists = document.querySelectorAll('[data-profile-cards-list]');
  const filterEls = document.querySelectorAll('[data-student-filter]');
  filterEls.forEach((filterEl) => {
    const cardEls = document.querySelectorAll(filterEl.dataset.studentFilter);
    filterEl.addEventListener('input', () => {
      cardEls.forEach((cardEl) => {
        // If the search matches the name, show the card, if not, hide it.
        if (matchWords(cardEl.dataset.name, filterEl.value)) {
          showElement(cardEl, hiddenClassName);
        } else {
          hideElement(cardEl, hiddenClassName);
        }
      });

      // Add/remove filtered appearance.
      profileCardsLists.forEach((profileCardsList) => {
        if (filterEl.value === '') {
          removeFilterClass(profileCardsList, filteredClassName);
        } else {
          addFilterClass(profileCardsList, filteredClassName);
        }
      });

      // Reload masonry after update
      profileCardMasonry.layout();
    });
  });
}

